
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmTabs } from "@afe/amui/src/components/Tabs";
import { AmIcon } from "@afe/amui/src/components/Icon";
import { AmRadio } from "@afe/amui/src/components/Radio";

import debounce from "lodash/debounce";
import get from "lodash/get";

@Component({
  components: { AmTypography, AmTabs, AmIcon, AmRadio }
})
export default class extends Vue {
  @Prop(String) readonly value!: string;
  @Prop(String) readonly search!: string;
  @Prop(String) readonly label!: string;
  @Prop(String) readonly sortType!: string;
  @Prop(Boolean) readonly hasSortType!: boolean;
  @Prop(Object) readonly instruments!: any;
  @Prop(String) readonly path!: string;
  @Prop(Object) readonly messages!: any;
  @Prop(Function) readonly groupUrl!: any;
  @Prop(Function) readonly groupPath!: any;

  handleSearch: any;

  async onTyping(value: string) {
    this.$emit("input", value);
  }

  get esg() {
    if (this.path.indexOf(".") > -1) {
      return null;
    }

    const index = this.instruments[this.path].findIndex(({ esg }: any) => esg);

    if (index === -1) {
      return null;
    }

    return {
      name: this.instruments[this.path][index].name,
      totalCount: this.instruments[this.path][index].itemsCount,
      id: this.instruments[this.path][index].id,
      index
    };
  }

  onExpandEsg() {
    if (!this.esg) {
      return;
    }

    const item = get(this.instruments, `${this.path}.${this.esg.index}`);
    const path = item.subtype
      ? `${this.path}.${this.esg.index}.subtype`
      : `${this.path}.${this.esg.index}.instruments`;

    this.$emit("change", path);
  }

  mounted() {
    this.handleSearch = debounce(this.onTyping, 200);
  }
}
